import { CalendarDays } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';

export type TaskEventDateIconProps = Omit<
  ComponentPropsWithoutRef<typeof CalendarDays>,
  'children'
>;

/**
 * Calendar icon used in task/event date rows. Renders the lucide
 * `calendar-days` glyph (a calendar grid with 6 day cells) per the
 * design system (Figma node 7900:50932).
 */
export function TaskEventDateIcon({
  size = 24,
  ...props
}: TaskEventDateIconProps) {
  return (
    <CalendarDays
      size={size}
      {...props}
    />
  );
}
